import React, { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { FiLogOut } from "react-icons/fi";

/**
 * Renders a sign-out button.
 */
export const SignOutButton = ({ className = "btn btn-primary bi bi-door-open-fill" }) => {
  const { instance } = useMsal();

  const handleLogout = (logoutType) => {
    try {
      if (logoutType === "popup") {
        instance.logoutPopup({
          postLogoutRedirectUri: "/pass/login",
          mainWindowRedirectUri: "/pass/login",
        });
        sessionStorage.removeItem("userInfo");
      } else if (logoutType === "redirect") {
        instance.logoutRedirect({
          postLogoutRedirectUri: "/pass/login",
          mainWindowRedirectUri: "/pass/login",
        });
      }
    } catch (error) {
      console.error("Logout error:", error);
    }
  };

  useEffect(() => {
    const handleBeforeUnload = () => {};

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [instance]);

  return (
    <button onClick={() => handleLogout("popup")} type="button" className={className}>
        <span className="logout-icon">
            <FiLogOut />
        </span> 
        Sign Out
    </button>
  );
};
